export default __webpack_public_path__ + "static/media/login_bg.2976cdb6.svg";